import React, { useEffect, useRef, useState } from "react";
import "./Verification.css";
import mailCheckIcon from "../../assets/mailSucces.svg";
import { useAuth } from "../../utils/AuthContext";
import mailIcon from "../../assets/mailResend.svg";
import { useNavigate } from "react-router-dom";

export default function Verification() {
    const { user, sendVerification, logoutUser, setAuth, checkUserStatus } =
        useAuth();
    const [isResending, setIsResending] = useState(false);
    const [resendSuccess, setResendSuccess] = useState(false);
    const hasSentInitialEmail = useRef(false); // Track initial send
    const navigate = useNavigate();

    useEffect(() => {
        const hasSentEmail = sessionStorage.getItem("verificationEmailSent");

        // Only send if session flag not set AND we haven't sent in this component instance
        if (!hasSentEmail && !hasSentInitialEmail.current) {
            hasSentInitialEmail.current = true; // Mark as sent
            const sendEmail = async () => {
                try {
                    await sendVerification();
                    sessionStorage.setItem("verificationEmailSent", "true");
                } catch (error) {
                    console.error("Failed to send verification email:", error);
                    sessionStorage.removeItem("verificationEmailSent");
                    hasSentInitialEmail.current = false; // Reset on failure
                }
            };

            sendEmail();
        }
    }, [sendVerification]); // Keep dependency but add safety checks

    useEffect(() => {
        if (!user) {
            navigate("/login");
            return;
        }

        let intervalId;

        if (!user.emailVerification) {
            // Start checking every 5 seconds if not verified
            intervalId = setInterval(() => {
                checkUserStatus();
            }, 4000);
        }

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    }, [user, checkUserStatus, navigate]);

    useEffect(() => {
        if (user?.emailVerification) {
            sessionStorage.removeItem("verificationEmailSent");
            navigate("/setup");
        }
    }, [user, setAuth, navigate]);

    const handleResend = async () => {
        setIsResending(true);
        try {
            await sendVerification();
            setResendSuccess(true);
            setTimeout(() => setResendSuccess(false), 3000);
        } catch (error) {
            console.error("Resend failed:", error);
        } finally {
            setIsResending(false);
        }
    };

    const handleChangeEmail = () => {
        sessionStorage.removeItem("verificationEmailSent");
        navigate("/signup");
        logoutUser();
    };

    return (
        <>
            <title>Confirm Your Account | Oakmate</title>
            <meta
                name="description"
                content="Finalize your Oakmate account setup by confirming your email."
            />
            <div className="verifyPage">
                <div className="verify">
                    <div className="auth-component">
                        <img
                            src={mailCheckIcon}
                            alt="mailCheckIcon"
                            className="mailCheckIcon"
                        />
                        <div className="auth-header-wrapper">
                            <div className="auth-header">
                                Email Verification
                            </div>
                            <div className="auth-subheader">
                                Please check your inbox
                            </div>
                        </div>
                        <div className="sentEmailTo">
                            Email send to <br />
                            <span>{user?.email}</span>
                        </div>
                        <button
                            className={`signInGoogle ${
                                isResending ? "loading" : ""
                            }`}
                            onClick={handleResend}
                            disabled={isResending}
                        >
                            <img
                                src={mailIcon}
                                alt="mailIcon"
                                className="mailIcon"
                            />
                            <div className="signInGoogle-text">
                                {isResending
                                    ? "Sending..."
                                    : "Didn't receive? Resend."}
                            </div>
                        </button>
                        {resendSuccess && (
                            <div className="resend-success">
                                Verification email sent again!
                            </div>
                        )}
                        <div
                            className="forgot-password"
                            onClick={handleChangeEmail}
                        >
                            Change email address
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
